/**
 * Configurações globais de API.
 *
 * O hostname é lido dinamicamente de `window.location` para que o front-end
 * funcione em qualquer subdomínio sem reconfiguração.
 *
 * A variável de ambiente VITE_API_SUFFIX define apenas o sufixo de porta/path:
 *   - Com porta:   VITE_API_SUFFIX=":3000"        → http://cliente.dominio.com.br:3000
 *   - Com path:    VITE_API_SUFFIX=":3000/api"     → http://cliente.dominio.com.br:3000/api
 *   - Sem porta:   VITE_API_SUFFIX=""              → https://cliente.dominio.com.br
 *
 * Fallback: se VITE_BASE_URL estiver definida (uso local/dev), ela tem prioridade.
 */
const staticBaseUrl = import.meta.env.VITE_BASE_URL as string | undefined;
const apiSuffix = (import.meta.env.VITE_API_SUFFIX as string | undefined) ?? "";

function buildBaseUrl(): string {
  if (staticBaseUrl) return staticBaseUrl;

  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}${apiSuffix}`;
}

export const BASE_URL = buildBaseUrl();
